// ===================================================
// RELATÓRIO DE PRODUÇÃO
// ===================================================
function renderRelProducao(){
  const hoje = today();
  const ini = document.getElementById('rp-ini')?.value || toLocalISODate(new Date(new Date().getFullYear(),new Date().getMonth(),1));
  const fim = document.getElementById('rp-fim')?.value || hoje;
  if(document.getElementById('rp-ini')) document.getElementById('rp-ini').value = ini;
  if(document.getElementById('rp-fim')) document.getElementById('rp-fim').value = fim;

  const ordens = DB.get('ordens').filter(o=>{
    if(!o.data) return false;
    return o.data >= ini && o.data <= fim;
  });

  const concluidas = ordens.filter(o=>o.status==='concluido');
  const emExec = ordens.filter(o=>o.status==='execucao');
  const agendadas = ordens.filter(o=>o.status==='agendado');
  const canceladas = ordens.filter(o=>o.status==='cancelado');

  // Cards summary
  const cardsEl = document.getElementById('rp-cards');
  if(cardsEl) cardsEl.innerHTML = [
    {label:'Concluídas',val:concluidas.length,icon:'✅',color:'#00d4aa'},
    {label:'Em Execução',val:emExec.length,icon:'⚡',color:'#6c63ff'},
    {label:'Agendadas',val:agendadas.length,icon:'📌',color:'#ffa94d'},
    {label:'Total período',val:ordens.length,icon:'📌',color:'#74c0fc'},
  ].map(c=>`<div class="card"><div class="card-icon" style="color:${c.color}">${c.icon}</div><div class="card-val">${c.val}</div><div class="card-label">${c.label}</div></div>`).join('');

  const el = document.getElementById('rp-content');
  if(!el) return;

  // By type
  const porTipo = {};
  ordens.forEach(o=>{
    const t = OS_TIPOS[o.tipo]?.label||o.tipo||'Outro';
    if(!porTipo[t]) porTipo[t]={total:0,conc:0};
    porTipo[t].total++;
    if(o.status==='concluido') porTipo[t].conc++;
  });

  // By responsible
  const porResp = {};
  ordens.forEach(o=>{
    const r = o.resp||'Não atribuído';
    if(!porResp[r]) porResp[r]={total:0,conc:0,tipos:{}};
    porResp[r].total++;
    if(o.status==='concluido') porResp[r].conc++;
    const t = OS_TIPOS[o.tipo]?.label||o.tipo||'Outro';
    porResp[r].tipos[t]=(porResp[r].tipos[t]||0)+1;
  });

  // Timeline dos últimos 4 semanas
  const semanas = {};
  concluidas.forEach(o=>{
    const d = new Date(o.data+'T00:00:00');
    const wk = `${d.getFullYear()}-W${String(getWeekNum(d)).padStart(2,'0')}`;
    semanas[wk]=(semanas[wk]||0)+1;
  });

  el.innerHTML = `
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px">
      <div style="background:var(--surface);border:1px solid var(--border);border-radius:12px;padding:16px">
        <div style="font-weight:700;margin-bottom:12px;font-size:14px">Por tipo de serviço</div>
        ${Object.entries(porTipo).sort((a,b)=>b[1].total-a[1].total).map(([tipo,d])=>{
          const pct = d.total>0?Math.round(d.conc/d.total*100):0;
          return `<div style="margin-bottom:10px">
            <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:4px">
              <span>${tipo}</span><span style="color:var(--muted)">${d.conc}/${d.total} (${pct}%)</span>
            </div>
            <div style="background:var(--border);border-radius:4px;height:6px">
              <div style="width:${pct}%;background:#00d4aa;height:6px;border-radius:4px"></div>
            </div>
          </div>`;
        }).join('')||'<div style="color:var(--muted);font-size:13px">Sem dados</div>'}
      </div>
      <div style="background:var(--surface);border:1px solid var(--border);border-radius:12px;padding:16px">
        <div style="font-weight:700;margin-bottom:12px;font-size:14px">Por responsável</div>
        ${Object.entries(porResp).sort((a,b)=>b[1].total-a[1].total).map(([resp,d])=>{
          const pct = d.total>0?Math.round(d.conc/d.total*100):0;
          const tipos = Object.entries(d.tipos).map(([t,n])=>`${t}(${n})`).join(', ');
          return `<div style="margin-bottom:10px">
            <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:2px">
              <span style="font-weight:600">👤 ${resp}</span><span style="color:#00d4aa;font-weight:700">${d.conc}/${d.total}</span>
            </div>
            <div style="font-size:11px;color:var(--muted);margin-bottom:4px">${tipos}</div>
            <div style="background:var(--border);border-radius:4px;height:5px">
              <div style="width:${pct}%;background:#6c63ff;height:5px;border-radius:4px"></div>
            </div>
          </div>`;
        }).join('')||'<div style="color:var(--muted);font-size:13px">Sem dados</div>'}
      </div>
    </div>

    <div style="background:var(--surface);border:1px solid var(--border);border-radius:12px;padding:16px;margin-bottom:16px">
      <div style="font-weight:700;margin-bottom:12px;font-size:14px">OS Concluídas no período (${concluidas.length})</div>
      ${concluidas.length?`<table style="width:100%;border-collapse:collapse;font-size:13px">
        <thead><tr style="border-bottom:2px solid var(--border)">
          <th style="padding:8px;text-align:left">Data</th>
          <th style="padding:8px;text-align:left">Tipo</th>
          <th style="padding:8px;text-align:left">Cliente</th>
          <th style="padding:8px;text-align:left">Endereço</th>
          <th style="padding:8px;text-align:left">Responsável</th>
        </tr></thead>
        <tbody>${concluidas.sort((a,b)=>b.data>a.data?1:-1).map(o=>`<tr style="border-bottom:1px solid var(--border)">
          <td style="padding:8px;white-space:nowrap">${fmtData(o.data)}</td>
          <td style="padding:8px">${OS_TIPOS[o.tipo]?.icon||''} ${OS_TIPOS[o.tipo]?.label||o.tipo}</td>
          <td style="padding:8px">${escapeHtml(o.cliente||'—')}</td>
          <td style="padding:8px;font-size:11px;color:var(--muted)">${escapeHtml(o.end||'—')}</td>
          <td style="padding:8px">${escapeHtml(o.resp||'—')}</td>
        </tr>`).join('')}</tbody>
      </table>`:`<div style="color:var(--muted);text-align:center;padding:24px">Nenhuma OS concluída no período</div>`}
    </div>`;
}

function getWeekNum(d){
  const startOfYear = new Date(d.getFullYear(),0,1);
  return Math.ceil(((d-startOfYear)/86400000+startOfYear.getDay()+1)/7);
}

